module.exports = __webpack_public_path__ + "img/wave-left-color.6344614d.svg";